"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "codeFromName", {
    enumerable: true,
    get: function() {
        return codeFromName;
    }
});
const _interop_require_default = require("@swc/helpers/_/_interop_require_default");
const _snakeCase = /*#__PURE__*/ _interop_require_default._(require("lodash/snakeCase"));
function codeFromName(name) {
    return (0, _snakeCase.default)(name).toLowerCase();
}

//# sourceMappingURL=code-from-name.js.map